import { bl_cms_form_submission_ext_RowClass, bl_cms_form_submission_hdr_RowClass } from '../../../dbschema';
import {BaseContainerModel} from '../../base-container.model';

export class CmsFormSubmissionContainerModel extends BaseContainerModel {
    bl_cms_form_submission_hdr: bl_cms_form_submission_hdr_RowClass = new bl_cms_form_submission_hdr_RowClass();
    bl_cms_form_submission_exts: bl_cms_form_submission_ext_RowClass[] = [];
}